import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import toast from 'react-hot-toast';
import './AdminMessages.css';
import AdminDiscountCodes from '../../components/AdminDiscountCodes/AdminDiscountCodes';
import AdminBlog from '../../components/AdminBlog/AdminBlog';

function AdminMessages() {
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedMessage, setSelectedMessage] = useState(null);
    const [currentUser, setCurrentUser] = useState(null);
    const [activeTab, setActiveTab] = useState('messages'); // اضافه کن: 'messages' یا 'discounts'

    useEffect(() => {
        const userData = localStorage.getItem('currentUser');
        if (userData) {
            const user = JSON.parse(userData);
            if (user.role !== 'admin') {
                window.location.href = '/';
                return;
            }
            setCurrentUser(user);
            fetchMessages();
        } else {
            window.location.href = '/login';
        }
    }, []);

    const fetchMessages = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/contact/messages`);
            setMessages(response.data.data);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching messages:", error);
            toast.error('خطا در دریافت پیام‌ها');
            setLoading(false);
        }
    };

    const handleMarkAsRead = async (id) => {
        try {
            await axios.put(`${process.env.REACT_APP_API_URL}/contact/message/${id}/read`);
            setMessages(messages.map(msg => 
                msg._id === id ? { ...msg, isRead: true } : msg
            ));
            if (selectedMessage?._id === id) {
                setSelectedMessage({ ...selectedMessage, isRead: true });
            }
            toast.success('پیام به عنوان خوانده شده علامت گذاری شد');
        } catch (error) {
            console.error("Error marking as read:", error);
            toast.error('خطا در علامت گذاری');
        }
    };

    const handleDeleteMessage = async (id) => {
        if (window.confirm('آیا از حذف این پیام مطمئن هستید؟')) {
            try {
                await axios.delete(`${process.env.REACT_APP_API_URL}/contact/message/${id}`);
                setMessages(messages.filter(msg => msg._id !== id));
                if (selectedMessage?._id === id) {
                    setSelectedMessage(null);
                }
                toast.success('پیام حذف شد');
            } catch (error) {
                console.error("Error deleting message:", error);
                toast.error('خطا در حذف پیام');
            }
        }
    };

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString('fa-IR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    if (loading) {
        return (
            <>
                <Navbar />
                <div className="loading-container">در حال بارگذاری...</div>
                <Footer />
            </>
        );
    }

    return (
        <>
            <Navbar />
            <div className="admin-messages-container">
                <div className="container mt-4">
                    {/* تب‌ها */}
                    <div className="admin-tabs">
                        <button 
                            className={`tab-btn ${activeTab === 'messages' ? 'active' : ''}`}
                            onClick={() => setActiveTab('messages')}
                        >
                            📬 پیام‌های تماس
                            <span className="tab-badge">{messages.filter(m => !m.isRead).length}</span>
                        </button>
                        <button 
                            className={`tab-btn ${activeTab === 'discounts' ? 'active' : ''}`}
                            onClick={() => setActiveTab('discounts')}
                        >
                            🏷️ مدیریت کدهای تخفیف
                        </button>
                        // در بخش تب‌ها:
                        <button className={`tab-btn ${activeTab === 'blog' ? 'active' : ''}`} onClick={() => setActiveTab('blog')}>
                            📝 مدیریت مقالات
                        </button>
                    </div>

                    {/* محتوای تب پیام‌ها */}
                    {activeTab === 'messages' && (
                        <>
                            <h2 className="text-center mb-4">📬 مدیریت پیام‌های تماس با ما</h2>
                            
                            <div className="messages-grid">
                                {/* لیست پیام‌ها */}
                                <div className="messages-list">
                                    <div className="messages-header">
                                        <span>پیام‌ها ({messages.length})</span>
                                        <span className="unread-count">
                                            خوانده نشده: {messages.filter(m => !m.isRead).length}
                                        </span>
                                    </div>
                                    {messages.length === 0 ? (
                                        <div className="no-messages">هیچ پیامی وجود ندارد</div>
                                    ) : (
                                        messages.map(message => (
                                            <div 
                                                key={message._id} 
                                                className={`message-item ${!message.isRead ? 'unread' : ''} ${selectedMessage?._id === message._id ? 'active' : ''}`}
                                                onClick={() => setSelectedMessage(message)}
                                            >
                                                <div className="message-subject">{message.subject}</div>
                                                <div className="message-sender">{message.name} - {message.email}</div>
                                                <div className="message-date">{formatDate(message.createdAt)}</div>
                                                {!message.isRead && <span className="unread-badge">جدید</span>}
                                            </div>
                                        ))
                                    )}
                                </div>
                                
                                {/* جزئیات پیام */}
                                <div className="message-detail">
                                    {selectedMessage ? (
                                        <>
                                            <div className="detail-header">
                                                <h3>{selectedMessage.subject}</h3>
                                                <div className="detail-actions">
                                                    {!selectedMessage.isRead && (
                                                        <button 
                                                            className="btn-mark-read"
                                                            onClick={() => handleMarkAsRead(selectedMessage._id)}
                                                        >
                                                            ✓ علامت به عنوان خوانده شده
                                                        </button>
                                                    )}
                                                    <button 
                                                        className="btn-delete"
                                                        onClick={() => handleDeleteMessage(selectedMessage._id)}
                                                    >
                                                        🗑️ حذف
                                                    </button>
                                                </div>
                                            </div>
                                            
                                            <div className="detail-info">
                                                <p><strong>از:</strong> {selectedMessage.name}</p>
                                                <p><strong>ایمیل:</strong> {selectedMessage.email}</p>
                                                <p><strong>تاریخ:</strong> {formatDate(selectedMessage.createdAt)}</p>
                                                <p><strong>وضعیت:</strong> {selectedMessage.isRead ? '✓ خوانده شده' : '🔴 خوانده نشده'}</p>
                                            </div>
                                            
                                            <div className="detail-message">
                                                <h4>متن پیام:</h4>
                                                <p>{selectedMessage.message}</p>
                                            </div>
                                            
                                            <div className="reply-section">
                                                <h4>پاسخ سریع:</h4>
                                                <a href={`mailto:${selectedMessage.email}?subject=پاسخ به پیام شما: ${selectedMessage.subject}`} 
                                                   className="btn-reply"
                                                   target="_blank"
                                                   rel="noopener noreferrer">
                                                    📧 پاسخ از طریق ایمیل
                                                </a>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="no-selection">
                                            <p>برای مشاهده جزئیات، روی یک پیام کلیک کنید</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </>
                    )}

                    {/* محتوای تب کدهای تخفیف */}
                    {activeTab === 'discounts' && (
                        <AdminDiscountCodes />
                    )}
                    {activeTab === 'blog' && <AdminBlog />}
                </div>
            </div>
            <Footer />
        </>
    );
}

export default AdminMessages;